<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-toolbar v-if="user.profile">
      <v-toolbar-title
        >{{ user.profile.first_name }}
        {{ user.profile.last_name }}</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="$router.go(-1)">
        <v-icon left>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-toolbar>

    <v-sheet v-if="user.profile" class="mt-5 pa-5" tile>
      <v-container grid-list-xl>
        <v-layout wrap>
          <v-flex xs12 md4>
            <v-text-field
              v-model="user.username"
              label="Username"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="user.password"
              label="Password"
              append-icon="mdi-eye-off"
              disabled
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="user.email"
              label="E-mail"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="user.profile.salutation"
              label="Salutation"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="user.profile.first_name"
              label="First name"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="user.profile.last_name"
              label="Last name"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="user.profile.gender"
              label="Gender"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="user.profile.marital_status"
              label="Marital status"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="user.profile.birth_date"
              label="Birthday date"
              append-icon="mdi-calendar"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="user.profile.mobile_phone"
              label="Mobile phone"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="user.profile.phone"
              label="Phone"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="user.profile.language"
              label="Language"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="user.profile.street"
              label="Street"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="user.profile.zip"
              label="ZIP"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="user.profile.city"
              label="City"
              readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: 'UsersShow',

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    user: {},
    error: null,
    overlay: true
  }),

  created() {
    this.$store.dispatch('user/retrieveUser', this.id).then(({ data }) => {
      this.overlay = false;
      this.user = data;
    });
  }
};
</script>
